import { useMemo } from "react";
import { createMemoryRouter, RouterProvider } from "react-router-dom";

import routes from "./app/routes";
import { PackageContext } from "./quote/context/PackageContext";

interface Props {
  packageId: number;
  groupSize?: number;
  arrivalDate?: string;
  drawerId: string;
}

const App = ({ packageId, groupSize, arrivalDate, drawerId }: Props) => {
  const packageContext = {
    packageId,
    groupSize,
    arrivalDate,
    drawerId,
  };
  const router = useMemo(() => createMemoryRouter(routes), []);

  return (
    <PackageContext.Provider value={packageContext}>
      <RouterProvider router={router} />
    </PackageContext.Provider>
  );
};

export default App;
